import { Price } from '@jusbrasil-web/shared-price'

import { BenefitsList } from '../benefits-list'
import { LawsuitTwoOfferPlanCard_OfferLockCardFragment } from './__generated__/lawsuit-two-offer-plan-card.graphql'
import styles from './lawsuit-two-offer-plan-card.module.scss'

// Non-breaking space (&nbsp;). Used as placeholder content so the hidden
// Price.Title element reserves vertical space — empty JSX would collapse
// to zero height and break the alignment between sibling cards.
const NON_BREAKING_SPACE = '\u00A0'

export function LawsuitPlanBenefits({
  offerLockCard,
}: {
  offerLockCard: LawsuitTwoOfferPlanCard_OfferLockCardFragment
}) {
  return (
    <div className={styles['two-offer-lock-card-benefits']}>
      <BenefitsList offerLockCard={offerLockCard} />
    </div>
  )
}

export function LawsuitPlanPriceInfo({
  offer,
  reserveTitleSpace,
}: {
  offer: LawsuitTwoOfferPlanCard_OfferLockCardFragment['offer']
  reserveTitleSpace?: boolean
}) {
  const { priceTitle, priceText, frequency } = offer

  return (
    <Price align="center" size="md" className={styles['two-offer-lock-card-price']}>
      {priceTitle && <Price.Title>{priceTitle}</Price.Title>}
      {!priceTitle && reserveTitleSpace && (
        <Price.Title className={styles['two-offer-lock-card-price-placeholder']}>
          {NON_BREAKING_SPACE}
        </Price.Title>
      )}
      <Price.Value>
        {priceText}
        {frequency && <Price.ValueFrequency>{frequency}</Price.ValueFrequency>}
      </Price.Value>
    </Price>
  )
}
